import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./leaderboard.css";
import ASSETS from "../../../app/config/assets";
import Button from "../../atoms/buttons/Button";
import { GiPodiumWinner, GiPodiumSecond, GiPodiumThird } from "react-icons/gi";
import { PiHandsClappingLight } from "react-icons/pi";
import { capitalizeAll, convertDuration } from "../../../core/utils/helpers";
import PlayerChallengeReport from "../player-challenge-report/PlayerChallengeReport";
import { useDispatch, useSelector } from "react-redux";
import { challengeSlice } from "../../../app/store/slices/challengeSlice";

const LeaderBoard = ({ is_completed, data, challenge_type, setView }) => {
  const [isReport, setIsReport] = useState();
  const _scoreboard = data?.scores;
  const _report = data?.report;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const connectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser.connectedUserData,
  );

  const _sys_role = connectedUser?.userInfo?.sys_role;

  const goToHome = () => {
    if (is_completed) {
      dispatch(
        challengeSlice?.actions?.setCurrentAssessment({
          mode: null,
          admission_test_id: null,
          challenge_id: null,
          challenge_type: null,
          teams_breakdown: null,
          teams_device: null,
          request_id: null,
        }),
      );
      navigate(`/${_sys_role}/challenges`, { replace: true });
    } else {
      setView("preload");
    }
  };

  return (
    <div className="leaderboard">
      <div className="leaderboard-wrapper">
        <div className="lw-head">
          <h1>Challenge's {isReport ? "Report" : "Scoreboard"}</h1>
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={
              is_completed
                ? "Finish and Close Report"
                : "Close and Go to Next question!"
            }
            action={() => goToHome()}
          />
        </div>
        <div className="lw-actions">
          <Button
            type={"button"}
            preferedStyle={isReport ? "default" : "normal"}
            title={"Click to view ScoresBoard"}
            action={() => setIsReport(!isReport)}
          />
          <Button
            type={"button"}
            preferedStyle={isReport ? "normal" : "default"}
            title={"Click to view Report"}
            action={() => setIsReport(!isReport)}
          />
        </div>
        <div className="lw-ruban">
          {isReport ? (
            <span>
              This is challenge's report that present questions and every single
              details about for a good <strong>understanding.</strong>
            </span>
          ) : (
            <span>
              This is Challenge's evolution of the{" "}
              <strong>scoreboard and Podium</strong>
            </span>
          )}
        </div>
        <div className="lw-body">
          {isReport ? (
            <PlayerChallengeReport
              challenge_type={challenge_type}
              report_data={_report}
            />
          ) : (
            <>
              <div className="classment">
                {_scoreboard?.map((item, idx) => {
                  switch (parseInt(item?.ranking)) {
                    case 1:
                      return (
                        <div className="box box-1" key={idx + 1}>
                          <img
                            src={ASSETS.first}
                            alt="player ranking at first place"
                          />
                          <h2 className="title t-2">
                            {challenge_type === "classic"
                              ? capitalizeAll(item?.player_name)
                              : capitalizeAll(item?.team_name)}
                          </h2>
                          <h3 className="title t-3">{item?.score} Points</h3>
                          <p className="title t-4">
                            {item?.answer_questions} out of{" "}
                            {item?.total_questions} question(s)
                          </p>
                        </div>
                      );

                    case 2:
                      return (
                        <div className="box box-2" key={idx + 1}>
                          <img
                            src={ASSETS.second}
                            alt="player ranking at second place"
                          />
                          <h2 className="title t-2">
                            {challenge_type === "classic"
                              ? capitalizeAll(item?.player_name)
                              : capitalizeAll(item?.team_name)}
                          </h2>
                          <h3 className="title t-3">{item?.score} Points</h3>
                          <p className="title t-4">
                            {item?.answer_questions} out of{" "}
                            {item?.total_questions} question(s)
                          </p>
                        </div>
                      );

                    case 3:
                      return (
                        <div className="box box-3" key={idx + 1}>
                          <img
                            src={ASSETS.third}
                            alt="player ranking at third place"
                          />
                          <h2 className="title t-2">
                            {challenge_type === "classic"
                              ? capitalizeAll(item?.player_name)
                              : capitalizeAll(item?.team_name)}
                          </h2>
                          <h3 className="title t-3">{item?.score} Points</h3>
                          <p className="title t-4">
                            {item?.answer_questions} out of{" "}
                            {item?.total_questions} question(s)
                          </p>
                        </div>
                      );

                    default:
                      if (
                        (parseInt(item?.ranking) === 0 ||
                          parseInt(item?.ranking) > 3 ||
                          item?.ranking === "-") &&
                        item?.is_me
                      )
                        return (
                          <div className="box box-4" key={idx + 1}>
                            <span>Me</span>
                            <h2 className="title t-2">
                              {challenge_type === "classic"
                                ? capitalizeAll(item?.player_name)
                                : capitalizeAll(item?.team_name)}
                            </h2>
                            <h3 className="title t-3">{item?.score} Points</h3>
                            <p className="title t-4">
                              {item?.answer_questions} out of{" "}
                              {item?.total_questions} question(s)
                            </p>
                            <h3 className="title t-2">
                              {item?.ranking}
                              <sup>th</sup> place
                            </h3>
                          </div>
                        );
                  }
                })}
              </div>
              <div className="lw-content">
                {_scoreboard?.map((item, idx) => {
                  switch (parseInt(item?.ranking)) {
                    case 1:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position p-first">
                            {item?.ranking}
                          </span>
                          <GiPodiumWinner className="icon icon-first" />
                          <div className="player player-1">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              {challenge_type === "classic"
                                ? capitalizeAll(item?.player_name)
                                : capitalizeAll(item?.team_name)}
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.score}</p>
                            </div>
                            {item?.is_me && (
                              <>
                                <div className="tile">
                                  <span>Best timing</span>
                                  <p>{convertDuration(item?.best_timing)}</p>
                                </div>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.skipped_questions}</p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      );

                    case 2:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position p-second">
                            {item?.ranking}
                          </span>
                          <GiPodiumSecond className="icon icon-second" />
                          <div className="player player-2">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              {challenge_type === "classic"
                                ? capitalizeAll(item?.player_name)
                                : capitalizeAll(item?.team_name)}
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.score}</p>
                            </div>
                            {item?.is_me && (
                              <>
                                <div className="tile">
                                  <span>Best timing</span>
                                  <p>{convertDuration(item?.best_timing)}</p>
                                </div>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.skipped_questions}</p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      );

                    case 3:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position p-third">
                            {item?.ranking}
                          </span>
                          <GiPodiumThird className="icon icon-third" />
                          <div className="player player-3">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              {challenge_type === "classic"
                                ? capitalizeAll(item?.player_name)
                                : capitalizeAll(item?.team_name)}
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.score}</p>
                            </div>
                            {item?.is_me && (
                              <>
                                <div className="tile">
                                  <span>Best timing</span>
                                  <p>{convertDuration(item?.best_timing)}</p>
                                </div>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.skipped_questions}</p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      );

                    default:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position">{item?.ranking}</span>
                          <PiHandsClappingLight className="icon icon-remain-places" />
                          <div className="player">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              {challenge_type === "classic"
                                ? capitalizeAll(item?.player_name)
                                : capitalizeAll(item?.team_name)}
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.score}</p>
                            </div>
                            {item?.is_me && (
                              <>
                                <div className="tile">
                                  <span>Best timing</span>
                                  <p>{convertDuration(item?.best_timing)}</p>
                                </div>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.skipped_questions}</p>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      );
                  }
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeaderBoard;
